// extracted by mini-css-extract-plugin
module.exports = {"grid":"style_grid__1UbN9","column":"style_column__1dhrY","row":"style_row__3jE-T"};